import useTestId from '@ori/testid-generator';
import bemCssModules from 'bem-css-modules';
import { observer } from 'mobx-react-lite';
import type { VFC } from 'react';

import SearchResultsModuleCss from './SearchResults.module.css';
import { LocalizedText } from '~/components/LocalizedText/LocalizedText';
import { QuestionItem } from '~/components/QuestionItem/QuestionItem';
import { LocalizationItem, MAX_AMOUNT_ITEMS_TO_RENDER } from '~/constants';
import { useSearchResultStore } from '~/stores';

const block = bemCssModules(SearchResultsModuleCss);

export const SearchResults: VFC = observer(() => {
  const {
    searchQuery,
    searchResult,
    searchQuestions,
    loadSearchResults,
    setItemsToSkipForNextPage,
    resetItemsToSkip,
  } = useSearchResultStore();

  const { getTestId } = useTestId();

  const handleShowMore = async () => {
    if (searchQuestions.length < searchResult.TotalCount) {
      setItemsToSkipForNextPage();
      await loadSearchResults(searchQuery);
    }
  };

  const renderButton = () => {
    if (searchResult.TotalCount === searchQuestions.length) {
      resetItemsToSkip();

      return null;
    }

    if (searchResult.TotalCount > MAX_AMOUNT_ITEMS_TO_RENDER) {
      return (
        <button
          type="button"
          className={block('button')}
          onClick={handleShowMore}
        >
          <LocalizedText localizationItem={LocalizationItem.ShowMore} />
        </button>
      );
    }

    return null;
  };

  return (
    <div
      className={block()}
      data-testid={getTestId('search-results')}
    >
      {searchQuestions.map((questionItem) => (
        <QuestionItem
          key={questionItem.Question}
          questionItem={questionItem}
          truncate={undefined}
        />
      ))}

      {renderButton()}
    </div>
  );
});
